import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { WordMark } from "@/components/brand";
import AuthNav from "@/components/site/AuthNav";

const inputCls = "w-full bg-black/40 border border-white/10 rounded-md px-3 py-2.5 text-sm text-foreground focus:border-gold focus:outline-none";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { const { data } = await api.post("/auth/forgot-password", { email }); toast.success(data.message); setSent(true); }
    catch (err) { toast.error(apiErr(err)); } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-ink flex items-center justify-center p-6">
      <AuthNav />
      <div className="w-full max-w-sm text-center">
        <Link to="/"><WordMark size="text-4xl" /></Link>
        <h1 className="font-serif text-3xl mt-10 mb-2">Reset Password</h1>
        {sent ? (
          <p className="text-sm text-muted-foreground">If that account exists, a reset link has been sent to your email.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6">
            <input type="email" required placeholder="Your email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            <button disabled={loading} className="btn-gold w-full py-3 text-sm flex items-center justify-center gap-2" data-testid="forgot-submit">{loading ? <Loader2 className="animate-spin" size={16} /> : null} Send Reset Link</button>
          </form>
        )}
        <Link to="/login" className="text-sm text-gold mt-6 inline-block">Back to sign in</Link>
      </div>
    </div>
  );
}
